import React, { useEffect, useState } from 'react';
import localforage from 'localforage';
import { Container, Form, Button, Card } from 'react-bootstrap';
import { ToastContainer, toast } from 'react-toastify'; // Import ToastContainer and toast
import 'react-toastify/dist/ReactToastify.css';
import { loginAdmin } from '../API/Adminapi';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../AuthContext';

function AdminLoginForm() {
    const { setIsAuthenticated } = useAuth();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const data = await loginAdmin({ email, password });
            console.log("API response:", data);

            // Save token using localforage
            await localforage.setItem('token', data.token);
            await localforage.setItem('role', 'admin');

            toast.success('Login successful!');
            setIsAuthenticated(true);
            navigate('/admin/dashboard');
        } catch (error) {
            const errorMessage = error.response?.data?.message || 'An error occurred';
            toast.error(errorMessage);
            console.error("Login error:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        // Remove token on browser close or refresh
        const handleUnload = async () => {
            await localforage.removeItem('token');
        };

        window.addEventListener('beforeunload', handleUnload);
        return () => {
            window.removeEventListener('beforeunload', handleUnload);
        };
    }, []);

    return (
        <Container className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
            <Card style={{ width: '400px', backgroundColor: '#6c757d' }} className="p-4 rounded shadow-lg">
                <h4 className="text-center text-white mb-4">Log In To Admin Dashboard</h4>
                <Form onSubmit={handleSubmit}>
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Label className="text-white">Email</Form.Label>
                        <Form.Control
                            type="email"
                            placeholder="Enter email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="formBasicPassword">
                        <Form.Label className="text-white">Password</Form.Label>
                        <Form.Control
                            type="password"
                            placeholder="Password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                    </Form.Group>
                    <Button 
                        style={{ backgroundColor: '#888888', border: 'none' }} 
                        type="submit" 
                        className="w-100"
                        disabled={loading}
                    >
                        {loading ? 'Logging in...' : 'Login'}
                    </Button>
                </Form>
            </Card>

            {/* Toast container for showing toast notifications */}
            <ToastContainer position="top-right" autoClose={3000} hideProgressBar />
        </Container>
    );
}

export default AdminLoginForm;
